import SectionTopBg1 from '@/assets/img/tmp/bg_youtube1.png';
import SectionTopBg1M from '@/assets/img/tmp/bg_youtube1M@2x.png';
import SectionTopBg2 from '@/assets/img/tmp/bg_youtube2@2x.png';
import SectionTopBgM2 from '@/assets/img/tmp/bg_youtube2M@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import Button from './Button';
import Container from './Container';
import { Tit } from './Titles';

interface YoutubeProps {
  className?: string;
  title?: string;
  reserve?: boolean;
  tabs?: itemData[];
  noneTab?: boolean;
  bgType?: string | number;
}

export interface itemData {
  id: string | number;
  title: string;
  youtubeId: string;
}

const TabButton = styled(Button)<{ active: boolean }>`
  display: inline-block;
  height: 56px;
  line-height: 54px;
  border-radius: 56px;
  font-size: 20px;
  padding: 0 23px;
  white-space: nowrap;
  border-color: ${(props) => (props.active ? `#1cabe2` : `#f8f9fa`)};
  background-color: ${(props) => (props.active ? `#1cabe2` : `#f8f9fa`)};
  color: ${(props) => (props.active ? `#fff` : `#2d2926`)};
  position: relative;
  z-index: 1;
  cursor: pointer;

  ${breakpoint(`tablet`)} {
    height: auto;
    border-radius: 48px;
    line-height: normal;
    font-size: 16px;
    padding: 11px 16px;
    white-space: normal;
    text-align: left;
  }
`;
const PanelContainer = styled.div<YoutubeProps>`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  &.reserve {
    flex-direction: column-reverse;

    .btn-container {
      margin-top: 64px;
    }

    ${breakpoint(`tablet`)} {
      .btn-container {
        margin-top: 72px;
      }
    }
  }
  .btn-container {
    margin-bottom: 32px;
    width: 100%;
    //overflow-x: hidden;
    z-index: 1;

    .UiTabPanel {
      //display: inline-flex;
      text-align: left;
      margin-top: -16px;

      & > li {
        padding: 0;
        display: inline-block;
        margin: 0 16px 16px 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }

    ${breakpoint(`tablet`)} {
      margin-bottom: 48px;
    }
  }
`;
const VideoContainer = styled.div<YoutubeProps>`
  width: 100%;
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    background: url(${SectionTopBg1}) center top no-repeat;
    background-size: auto 100%;
    width: 1920px;
    height: 710px;

    /* TODO 분기처리 확인 */
    ${({ bgType }) => {
      if (bgType === `0`) {
        return `
        display: none;
      `;
      }
      if (bgType === `2`) {
        return `
        height: 708px;
        background-image: url(${SectionTopBg2});
      `;
      }
      return ``;
    }}
    ${breakpoint(1160)} {
      height: 61.21vw;
    }
  }

  .video-wrap {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    /* padding-top: 66.69%; */
    padding-top: 56.25%;
    position: relative;
  }
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  ${breakpoint(`tablet`)} {
    &::before {
      width: auto;
      height: 0;
      padding-top: 69.44%;
      background-image: url(${SectionTopBg1M});
      background-size: cover;
      left: -20px;
      right: -20px;
      transform: translate(0, 0);
      /* TODO 분기처리 확인 */
      ${({ bgType }) => {
        if (bgType === `0`) {
          return `
            display: none;
          `;
        }
        if (bgType === `2`) {
          return `
            background-image: url(${SectionTopBgM2});
          `;
        }
        return ``;
      }}
    }
  }
`;
const YoutubeContainer = styled.div`
  h2 {
    padding-bottom: 96px;
  }

  ${breakpoint(`tablet`)} {
    h2 {
      padding-bottom: 72px;
    }
  }
`;

const Youtube = styled<FC<YoutubeProps>>(
  ({
    title,
    className,
    tabs,
    reserve,
    noneTab,
    endViolence,
    ...YoutubeProps
  }) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabMenu = (id: number) => {
      setActiveTab(id);
    };

    return (
      <YoutubeContainer className={className && className}>
        <Container>
          {title ? (
            <h2>
              <Tit
                size="s1-5"
                color="sky"
                weight="normal"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </h2>
          ) : (
            ``
          )}
        </Container>

        <PanelContainer className={reserve && `reserve`}>
          {noneTab || (
            <div className="btn-container">
              <ul className="UiTabPanel">
                {tabs.map((row, idx) => (
                  <li key={idx}>
                    <TabButton
                      className="btn"
                      color="mint"
                      shape="round"
                      active={activeTab === idx}
                      onClick={() => handleTabMenu(idx)}
                    >
                      {row.title}
                    </TabButton>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {endViolence ? (
            <VideoContainer bgType="0">
              <div className="video-wrap">
                <iframe
                  className="video"
                  src={`https://www.youtube.com/embed/${endViolence}?controls=1&modestbranding=1&rel=0`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </VideoContainer>
          ) : (
            <VideoContainer>
              <div className="video-wrap">
                <iframe
                  className="video"
                  src={`https://www.youtube.com/embed/${tabs[activeTab].youtubeId}?controls=1&modestbranding=1&rel=0
                  `}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </VideoContainer>
          )}
        </PanelContainer>
      </YoutubeContainer>
    );
  },
)``;
export default Youtube;
